export const dogBreeds = [
  'Другое',
  'Австралийская короткохвостая пастушья собака',
  'Австралийская овчарка',
  'Австралийская пастушья собака',
  'Австралийский келпи',
  'Австралийский терьер',
  'Австралийский шелковистый терьер',
  'Австрийская гончая',
  'Австрийский брудастый бракк',
  'Австрийский Пенненсбрук',
  'Австрийский пинчер',
  'Азавак',
  'Азорская пастушья собака',
  'Аиди',
  'Акита-ину',
  'Алан',
  'Алано',
  'Алапахский бульдог',
  'Алопекис',
  'Альпийская таксообразная гончая',
  'Аляскинский кли-кай',
  'Аляскинский маламут',
  'Американская акита',
  'Американская эскимосская собака',
  'Американский бандог',
  'Американский булли',
  'Американский бульдог',
  'Американский водяной спаниель',
  'Американский голый терьер',
  'Американский кокер-спаниель',
  'Американский мастиф',
  'Американский питбультерьер',
  'Американский стаффордширский терьер',
  'Американский фоксхаунд',
  'Анатолийская овчарка',
  'Английская енотовая гончая',
  'Английская овчарка',
  'Английский бульдог',
  'Английский водяной спаниель',
  'Английский кокер-спаниель',
  'Английский мастиф',
  'Английский пойнтер',
  'Английский сеттер',
  'Английский спрингер-спаниель',
  'Английский той-терьер',
  'Английский фоксхаунд',
  'Англо-французская малая гончая',
  'Андалузский поденко',
  'Аппенцеллер зенненхунд',
  'Аргентинский дог',
  'Арденнский бувье',
  'Артезиано-нормандский бассет',
  'Артуазская гончая',
  'Арьежская гончая',
  'Афганская борзая',
  'Африканис',
  'Аффенпинчер',
  'Баварская горная гончая',
  'Бакхмуль',
  'Барбет',
  'Басенджи',
  'Баскская овчарка',
  'Бассет-хаунд',
  'Бедлингтон-терьер',
  'Белая швейцарская овчарка',
  'Бельгийская овчарка',
  'Бельгийский гриффон',
  'Бергамская овчарка',
  'Бернская гончая',
  'Бернский зенненхунд',
  'Бивер-йоркширский терьер',
  'Бигль',
  'Бишон-фризе',
  'Бладхаунд',
  'Блю-лейси',
  'Бобтейл',
  'Бойкин-спаниель',
  'Болгарская гончая',
  'Болгарская овчарка',
  'Болгарский барак',
  'Болоньез',
  'Большой вандейский бассет-гриффон',
  'Большой вандейский гриффон',
  'Большой мюнстерлендер',
  'Большой швейцарский зенненхунд',
  'Бордер-колли',
  'Бордер-терьер',
  'Бордоский дог',
  'Бородатый колли',
  'Босерон',
  'Бостон-терьер',
  'Бразильский терьер',
  'Бразильский фила',
  'Брак Дюпюи',
  'Бретонский эпаньоль',
  'Бриар',
  'Брохольмер',
  'Брюссельский гриффон',
  'Буковинская овчарка',
  'Бульдог кампейро',
  'Бульдог Катахулы',
  'Бульмастиф',
  'Бультерьер',
  'Бурбонский бракк',
  'Бурбуль',
  'Бурят-монгольский волкодав',
  'Валенсийский ратер',
  'Вандейский бассет-гриффон',
  'Веймаранер',
  'Вельш-корги',
  'Вельш-спрингер-спаниель',
  'Вельштерьер',
  'Венгерская борзая',
  'Венгерская выжла',
  'Венгерская жесткошёрстная выжла',
  'Вертельная собака',
  'Вест-хайленд-уайт-терьер',
  'Веттерхун',
  'Волчья собака Сарлоса',
  'Вольпино итальяно',
  'Восточноевропейская овчарка',
  'Восточносибирская лайка',
  'Гаванский бишон',
  'Гамильтонстёваре',
  'Гампр',
  'Гладкошёрстный фокстерьер',
  'Глен оф Имаал терьер',
  'Голландская овчарка',
  'Голландский смоусхонд',
  'Голубой гасконский бассет',
  'Голубой гасконский гриффон',
  'Голубой пикардийский спаниель',
  'Гончая Шиллера',
  'Грейхаунд',
  'Гренландская собака',
  'Греческая овчарка',
  'Гриффон Кортальса',
  'Грюнендаль',
  'Далматин',
  'Датско-шведская фермерская собака',
  'Денди-динмонт-терьер',
  'Джек-рассел-терьер',
  'Дзёмон-сиба',
  'Дирхаунд',
  'Длинношёрстный колли',
  'Доберман',
  'Дорги',
  'Дратхаар',
  'Древер',
  'Древесная енотовая гончая',
  'Дункер',
  'Евразиер',
  'Жесткошёрстный фокстерьер',
  'Западносибирская лайка',
  'Золотистый ретривер',
  'Ирландский водяной спаниель',
  'Ирландский волкодав',
  'Ирландский красно-белый сеттер',
  'Ирландский красный сеттер',
  'Ирландский мягкошёрстный пшеничный терьер',
  'Ирландский терьер',
  'Исландская собака',
  'Испанская водяная собака',
  'Испанская гончая',
  'Испанский гальго',
  'Испанский мастиф',
  'Итальянская гончая',
  'Итальянский бракк',
  'Итальянский спиноне',
  'Йоркширский терьер',
  'Ка-де-бо',
  'Кавалер-кинг-чарльз-спаниель',
  'Кавказская овчарка',
  'Каи',
  'Кан де паллейро',
  'Канадская эскимосская собака',
  'Канарский дог',
  'Кане-корсо',
  'Као де кастро-лаборейро',
  'Каракачанская собака',
  'Карело-финская лайка',
  'Карельская лайка',
  'Карельская медвежья собака',
  'Карликовый пинчер',
  'Каталонская овчарка',
  'Кеесхонд',
  'Керн-терьер',
  'Керри-блю-терьер',
  'Кинг-чарльз-спаниель',
  'Кинтамани',
  'Кисю',
  'Китайская хохлатая собака',
  'Китайский чунцин',
  'Кламбер-спаниель',
  'Коикерхондье',
  'Комондор',
  'Континентальный бульдог',
  'Континентальный той-спаниель',
  'Корейский чиндо',
  'Короткошёрстный колли',
  'Котон-де-тулеар',
  'Крашская овчарка',
  'Кромфорлендер',
  'Ксолоитцкуинтли',
  'Кубинский дог',
  'Кувас',
  'Кули',
  'Куньминская овчарка',
  'Кури (собака)',
  'Курцхаар',
  'Курчавошёрстный ретривер',
  'Лабрадор-ретривер',
  'Лабрадудль',
  'Лаготто-романьоло',
  'Лангхаар',
  'Ландсир',
  'Ланкаширский хилер',
  'Левретка',
  'Лейкленд-терьер',
  'Леонбергер',
  'Леопардовая собака Катахулы',
  'Лопарская оленегонная собака',
  'Лхасский апсо',
  'Майоркская овчарка',
  'Малая львиная собака',
  'Малая швейцарская гончая',
  'Малые бельгийские собаки',
  'Малый вандейский бассет-гриффон',
  'Малый мюнстерлендер',
  'Мальтийская болонка',
  'Мальтипу',
  'Манчестер-терьер',
  'Мареммо-абруццкая овчарка',
  'Махореро',
  'Меделян',
  'Миниатюрная американская овчарка',
  'Миттельшнауцер',
  'Мопс',
  'Московская сторожевая',
  'Муди',
  'Нагази',
  'Неаполитанский мастиф',
  'Немецкая овчарка',
  'Немецкий боксёр',
  'Немецкий вахтельхунд',
  'Немецкий дог',
  'Немецкий пинчер',
  'Немецкий шпиц',
  'Немецкий штихельхаар',
  'Немецкий ягдтерьер',
  'Ненецкая лайка',
  'Нивернейский гриффон',
  'Новозеландская овчарка',
  'Новошотландский ретривер',
  'Норботтен-шпиц',
  'Норвежский бухунд',
  'Норвежский лундехунд',
  'Норвежский серый элкхунд',
  'Норвежский чёрный элкхунд',
  'Норвич-терьер',
  'Нормандская гончая',
  'Норфолк-спаниель',
  'Норфолк-терьер',
  'Ньюфаундленд',
  'Овернский бракк',
  'Одис',
  'Оттерхаунд',
  'Пагль',
  'Папийон',
  'Парсон-рассел-терьер',
  'Паттердейл-терьер',
  'Пекинес',
  'Перуанская голая собака',
  'Пикардийская овчарка',
  'Пикардийский спаниель',
  'Пила архентино',
  'Пиренейская горная собака',
  'Пиренейская овчарка',
  'Пиренейский мастиф',
  'Поденко ибиценко',
  'Поденко канарио',
  'Польская гончая',
  'Польская низинная овчарка',
  'Польская подгалянская овчарка',
  'Польский огар',
  'Польский харт',
  'Померанский шпиц',
  'Помски',
  'Понт-одемерский спаниель',
  'Португальская водяная собака',
  'Португальская овчарка',
  'Португальский поденгу',
  'Пражский крысарик',
  'Прямошёрстный ретривер',
  'Пти-брабансон',
  'Пудель',
  'Пудельпойнтер',
  'Пули',
  'Пуми',
  'Пхунсан',
  'Раджапалайям',
  'Рафейру ду Алентежу',
  'Ризеншнауцер',
  'Родезийский риджбек',
  'Ротвейлер',
  'Румынская карпатская овчарка',
  'Румынская миоритская овчарка',
  'Русская гончая',
  'Русская псовая борзая',
  'Русская салонная собака',
  'Русская цветная болонка',
  'Русский охотничий спаниель',
  'Русский той',
  'Русско-европейская лайка',
  'Рыжий бретонский бассет',
  'Рэт-терьер',
  'Рюкю',
  'Салюки',
  'Самоедская собака',
  'Сахалинский хаски',
  'Северная инуитская собака',
  'Сенбернар',
  'Сиба-ину',
  'Сибирский хаски',
  'Сикоку',
  'Силихем-терьер',
  'Скайтерьер',
  'Словацкая грубошёрстная легавая',
  'Словацкий копов',
  'Словацкий чувач',
  'Слюги',
  'Смоландская гончая',
  'Среднеазиатская овчарка (САО)',
  'Средний вандейский гриффон',
  'Стабихун',
  'Староанглийский бульдог',
  'Староанглийский бульдог (заново созданный)',
  'Староанглийский терьер',
  'Стародатский пойнтер',
  'Стаффордширский бультерьер',
  'Суссекс-спаниель',
  'Схипперке',
  'Тазы',
  'Тайваньская собака',
  'Тайган',
  'Тайский бангку',
  'Тайский риджбек',
  'Такса',
  'Тедди-рузвельт-терьер',
  'Теломиан',
  'Тентерфилд-терьер',
  'Течичи',
  'Тибетский мастиф',
  'Тибетский спаниель',
  'Тибетский терьер',
  'Той-бульдог',
  'Той-фокстерьер',
  'Торньяк',
  'Той-пудель',
  'Тоса-ину',
  'Трансильванская гончая',
  'Тувинская овчарка',
  'Уиппет',
  'Уругвайский симаррон',
  'Уэльская овчарка',
  'Фален',
  'Фараонова собака',
  'Фарфоровая гончая',
  'Филд-спаниель',
  'Финская гончая',
  'Финский лаппхунд',
  'Финский шпиц',
  'Фландрский бувье',
  'Фокстерьер',
  'Французский бульдог',
  'Французский спаниель',
  'Ханаанская собака',
  'Харьер',
  'Хеллефорсхунд',
  'Ховаварт',
  'Хоккайдо',
  'Хорватская овчарка',
  'Хортая борзая',
  'Цвергшнауцер',
  'Чау-чау',
  'Чёрно-подпалый кунхаунд',
  'Чёрный терьер',
  'Чесапик-бей-ретривер',
  'Чехословацкая волчья собака',
  'Чешская пастушья собака',
  'Чешский терьер',
  'Чинук',
  'Чирнеко дель Этна',
  'Чихуахуа',
  'Чукотская ездовая',
  'Шапендуа',
  'Шарпей',
  'Шарпланинская овчарка',
  'Шведский белый элкхунд',
  'Шведский вальхунд',
  'Шведский лаппхунд',
  'Швейцарская гончая',
  'Шелковистый виндхаунд',
  'Шелти',
  'Ши-тцу',
  'Шотландский сеттер',
  'Шотландский терьер',
  'Шьен партиколор а пуаль фризе',
  'Энтлебухер зенненхунд',
  'Эрдельтерьер',
  'Эстонская гончая',
  'Эштрельская овчарка',
  'Южнорусская овчарка',
  'Юрская гончая',
  'Якутская лайка',
  'Ямтхунд',
  'Японский терьер',
  'Японский хин',
  'Японский шпиц'
];

const dogBreedsMap = dogBreeds.map((breed, index) => ({
  key: index,
  value: breed
}));

export { dogBreedsMap };
